// @flow

export type CancellablePromise<T> = Promise<T> & { cancel: () => void }

export function makeCancelable<T>(promise: Promise<T>): CancellablePromise<T> {
  let cancel = () => {};

  const wrappedPromise = new Promise((resolve, reject) => {
    cancel = () => {
      resolve = null;
      reject = null;
    };

    promise.then(
      val => {
        if (resolve) resolve(val);
      },
      error => {
        if (reject) reject(error);
      }
    );
  });

  // We are modify a Promise<T> type here and adding a property that is not
  // allowed on a Promise<T>. This is only allowed because we are returning a
  // new custom type
  // $FlowFixMe
  wrappedPromise.cancel = cancel;

  // Flow sees a Promise<T> here because of how we constructed it above. We only
  // know if it the correct type now but to the assignment in the line above.
  // $FlowFixMe
  return wrappedPromise;
}